import { render, staticRenderFns } from "./hyzj_details.vue?vue&type=template&id=265c6a30&scoped=true&"
import script from "./hyzj_details.vue?vue&type=script&lang=js&"
export * from "./hyzj_details.vue?vue&type=script&lang=js&"
import style0 from "./hyzj_details.vue?vue&type=style&index=0&id=265c6a30&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265c6a30",
  null
  
)

export default component.exports